import trainingTokens from '@amzn/meridian-tokens/base/icon/training';

export const videoCommerceAllowedOnboardingStatus = [
  'CATALOG_SYNC_IN_PROGRESS',
  'ONBOARDING_COMPLETE',
];

// This is a temp config to support sell using videos, later will be dynamically served as the part of MFE
export const sellUsingVideosConfig = {
  name: 'Sell using Videos',
  path: '/sell-using-videos',
  icon: trainingTokens,
  hasButtons: false,
};
